{"browse_shop":"Visita il negozio","go_to_shop":"Vai al negozio","no_orders_found":"Nessun ordine trovato","title":"Ordini"}